import React from "react";
import ReactDOM from "react-dom/client";
import "./selectPortalDefaults";
/* 1. Design tokens (must be first) */
import "./styles/welinkDesignTokens.css";
import "bootstrap/dist/css/bootstrap.min.css";
/* 2. Base app styles */
import "./index.css";
import "./config/loadAppStyles";
import "./styles/responsiveOverrides.css";
import "./styles/rtlOverrides.css";
import "./styles/authSplit.css";
import "./styles/wljLocalUi.css";
import "./styles/wljIndustrialUi.css";
import "./styles/wljSafeUi.css";
import "./styles/wljResponsive.css";
/* 3. Foundation polish + screen tuning (last wins) */
import "./styles/wljFoundation.css";
import "./styles/wljScreenTuning.css";
import "./styles/wljThemeContrast.css";
import reportWebVitals from "./reportWebVitals";
import { LOGIN_BANNER_URL } from "./config/staticAssets";
import { cleanupLegacyServiceWorkers } from "./utility/cacheCleanup";
/* 4. Portal card glass (must load after gradient CSS) */
import "./styles/wljPortalGlass.css";
/* 5. Design system — final token-driven UI layer */
import "./styles/wljDesignSystem.css";
import { hideAppLoader } from "./utility/appLoader";
import { applyTheme, readStoredDarkMode } from "./utils/theme";

function showBootError(error) {
  const message = error?.stack || error?.message || String(error);
  const el = document.getElementById("root") || document.body;
  if (!el) return;
  el.innerHTML = `<div style="padding:24px;font-family:sans-serif;max-width:720px">
    <h1 style="font-size:20px;margin-bottom:12px">App failed to start</h1>
    <pre style="white-space:pre-wrap;color:#b42318">${message
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")}</pre>
  </div>`;
}

async function boot() {
  try {
    applyTheme(readStoredDarkMode());

    if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }

    document.documentElement.style.setProperty(
      "--wlj-login-banner-image",
      `url("${LOGIN_BANNER_URL}")`
    );

    cleanupLegacyServiceWorkers();

    const rootEl = document.getElementById("root");
    if (!rootEl) {
      throw new Error("Root element #root was not found");
    }

    const [
      { default: App },
      { GoogleOAuthProvider },
      { default: AppPortalHost },
      { default: ErrorBoundary },
      { default: AppGradientBackground },
    ] = await Promise.all([
      import("./App"),
      import("@react-oauth/google"),
      import("./components/Portal/AppPortalHost"),
      import("./ErrorBoundary"),
      import("./components/NeatGradientCanvas/AppGradientBackground"),
    ]);

    ReactDOM.createRoot(rootEl).render(
      <ErrorBoundary>
        <GoogleOAuthProvider clientId="1083740285274-tvvsachfqqlh5o9818f77dh55kko0nvs.apps.googleusercontent.com">
          <AppGradientBackground />
          <App />
          <AppPortalHost />
        </GoogleOAuthProvider>
      </ErrorBoundary>
    );
  } catch (error) {
    console.error("App failed to start", error);
    showBootError(error);
  } finally {
    hideAppLoader();
    reportWebVitals();
  }
}

boot();
